/* Aifuku prototype sections: scroll reveal, drag-scroll gallery, box-size toggle.
   Every entry point is idempotent and re-runs on shopify:section:load. */
(function () {
  'use strict';

  var reduced = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- scroll reveal ---------- */
  var observer = null;
  function revealIn(scope) {
    var nodes = (scope || document).querySelectorAll('.af-reveal:not([data-af-seen])');
    if (reduced.matches) {
      nodes.forEach(function (el) { el.dataset.afSeen = 'true'; el.classList.add('is-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });
    }
    nodes.forEach(function (el) { el.dataset.afSeen = 'true'; observer.observe(el); });
  }

  /* ---------- flavour gallery ---------- */
  function initGallery(root) {
    if (root.dataset.afGalleryInit === 'true') return;
    root.dataset.afGalleryInit = 'true';

    var gallery = root.querySelector('[data-af-gallery]');
    var prev = root.querySelector('[data-af-prev]');
    var next = root.querySelector('[data-af-next]');
    if (!gallery) return;

    function sync() {
      var max = gallery.scrollWidth - gallery.clientWidth;
      if (prev) prev.disabled = gallery.scrollLeft < 3;
      if (next) next.disabled = gallery.scrollLeft >= max - 3;
    }

    function move(dir) {
      var card = gallery.querySelector('.af-card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(gallery).columnGap) || 0;
      gallery.scrollBy({ left: dir * (card.offsetWidth + gap) * 2,
                         behavior: reduced.matches ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    gallery.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync, { passive: true });

    // Mouse drag-to-scroll. Touch already scrolls natively.
    var drag = null;
    var suppressUntil = 0;

    gallery.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: gallery.scrollLeft, id: e.pointerId, moved: false };
    });
    gallery.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 6) {
        drag.moved = true;
        gallery.setPointerCapture(e.pointerId);
        gallery.classList.add('is-dragging');
      }
      if (drag.moved) { e.preventDefault(); gallery.scrollLeft = drag.left - dx; }
    });
    function endDrag() {
      if (!drag) return;
      if (drag.moved) suppressUntil = performance.now() + 300;
      if (gallery.hasPointerCapture(drag.id)) gallery.releasePointerCapture(drag.id);
      drag = null;
      gallery.classList.remove('is-dragging');
    }
    gallery.addEventListener('pointerup', endDrag);
    gallery.addEventListener('pointercancel', endDrag);
    gallery.addEventListener('lostpointercapture', function () {
      drag = null; gallery.classList.remove('is-dragging');
    });
    gallery.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // A drag that ends on a card must not follow the card's link.
    gallery.addEventListener('click', function (e) {
      if (performance.now() < suppressUntil) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    sync();
  }

  /* ---------- collection box-size toggle ---------- */
  function initCollection(root) {
    if (root.dataset.afCollectionInit === 'true') return;
    root.dataset.afCollectionInit = 'true';

    var options = Array.prototype.slice.call(root.querySelectorAll('[data-af-option]'));
    var photo = root.querySelector('[data-af-collection-image]');
    var cta = root.querySelector('[data-af-collection-cta]');
    if (!options.length) return;

    function select(option) {
      options.forEach(function (o) { o.setAttribute('aria-pressed', String(o === option)); });
      if (photo && option.dataset.image) photo.src = option.dataset.image;
      if (cta && option.dataset.url) cta.href = option.dataset.url;
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () { select(option); });
      if (option.getAttribute('aria-pressed') === 'true') select(option);
    });
  }

  function initAll(scope) {
    var root = scope || document;
    revealIn(root);
    root.querySelectorAll('[data-af-flavours]').forEach(initGallery);
    root.querySelectorAll('[data-af-collection]').forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
